<template>
  <div class="panel-holder">
      <div class="close-holder">
        <a class="close" href="#" @click="close()"></a>
      </div>
    
      <div class="panel" @click="handleClick">
        <div v-html="body"></div>
      </div>
  </div>
  
</template>

<script>
export default {
  name: 'app-panel',
  props: ['body'],
  methods: {
    close() {
      this.$emit("closePanel", {});
    },
    handleClick(e) {
      console.log(e.target)
      if (e.target.tagName === 'A') {
        this.close()
      }
    }
  }
}
</script>

<style scoped>
.panel-holder {
  overflow: hidden;
}
.panel {
    color: #0c0c0c;
    text-align: left;
    padding: 60px;
    overscroll-behavior: contain;
}
.close-holder {
  height: 60px;
  width: calc(100% - 20px);
  background: #f2f2f2;
  position: fixed;
  left: 0;
  right: 0;
  z-index: 9999;
}
.slideout-panel .slideout-wrapper .slideout.my-slide-panel .close {
  top: 15px;
  left: calc(100% - 50px);
  width: 32px;
  height: 32px;
  color: #333;
  position: absolute;
  opacity: 1;
  transition: opacity 1s linear 0.7s;
}
.slideout-panel .slideout-wrapper .slideout.my-slide-panel.slideIn-enter-active .close {
  opacity: 0;
}
.slideout-panel .slideout-wrapper .slideout.my-slide-panel.slideIn-leave-active .close {
  display: none;
}
.close:before, .close:after {
  position: absolute;
  left: 15px;
  content: ' ';
  height: 33px;
  width: 2px;
  background-color: #333;
  transition: .3s all ease;
}
.close:before {
  transform: rotate(45deg);
}
.close:after {
  transform: rotate(-45deg);
}
.close:hover:before, .close:hover:after {
  background-color: #cc0000;
}

/* MEDIA QUERIES */
@media (max-width: 575px) {
  .panel {
    padding: 40px;
  }
  .slideout-panel .slideout-wrapper .slideout.my-slide-panel .close {
    left: calc(100% - 30px);
  }
}
@media (max-width: 400px) {
  .panel {
    padding: 40px 30px;
  }
}
</style>